import { createContext, PropsWithChildren, useContext } from 'react'
import { UseTimeLogConfigAdmin, useTimeLogConfigAdmin } from './hooks'

const stub = async () => ({ error: 'Out of TimeLogConfigAdminContext' })

export const TimeLogConfigAdminContext = createContext<UseTimeLogConfigAdmin>({
  data: null,
  loading: false,
  ref: null,
  handleUpdateFieldLabel: stub,
  handleResetFieldLabel: stub,
  handleAddThreshold: stub,
  handleUpdateThreshold: stub,
  handleDeleteThreshold: stub,
  handleAddIntrapartumThreshold: stub,
  handleUpdateIntrapartumThreshold: stub,
  handleDeleteIntrapartumThreshold: stub,
  handleAddDeliveryThreshold: stub,
  handleUpdateDeliveryThreshold: stub,
  handleDeleteDeliveryThreshold: stub,
})

export const useTimeLogConfigAdminContext = () => useContext(TimeLogConfigAdminContext)

export const TimeLogConfigAdminProvider = ({ children }: PropsWithChildren) => {
  const value = useTimeLogConfigAdmin()
  return (
    <TimeLogConfigAdminContext.Provider value={value}>
      {children}
    </TimeLogConfigAdminContext.Provider>
  )
}
